<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I want to thank my mom and dad for their constant support and encouragement. Thanks Dad for convincing me to query editors in the first place. I would like to thank Nikki for always replying to my quite annoying emails and I want to thank the staff at Austin Macauley for helping me bring my dream to life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?33efa166